import React, { PureComponent } from 'react'
import { Carousel } from 'antd'
import adBottom from './../assets/img/ad_bottom.png';
import adTop from  './../assets/img/ad_top.png';
import carouselImg1 from './../assets/img/carousel-img1.png';
import carouselImg2 from './../assets/img/carousel-img2.png'
export default class ADFrame extends PureComponent {
    render() {
        return (
            <div style={{width: 430, height: '100%', position: 'absolute', backgroundColor: 'rgba(160, 195, 255,0.13)'}}>
                <div style={{position: 'absolute', top: '60%', left:'50%', marginTop: -200, marginLeft: -143}}>
                    <JoyCarousel></JoyCarousel>
                </div>
                <img style = {{width: 430, height: '50%', position: 'absolute', bottom: 0}} 
                    src={adBottom} alt = 'ad_bottom'></img>
               
                <img style = {{width: 430, height: '15%'}} 
                    src={adTop} alt = 'ad_bottom'></img>
                <img src={carouselImg1} style={{width: 430, height: 'auto'}} alt='carousel-img'/>
            </div>
        )
    }
}

function JoyCarousel() {
    return (
        <div className="carousel-wrapper" style={{width: 285, height: 100, textAlign: 'center', userSelect: 'none'}}>
            <div className='subTitle' style={{ fontSize: 20, lineHeight: '34px'}}>
            整合即时通讯、多维通讯录、协<br />同应用、共享日历和专属工作<br />台，提供智能办公体验。
            </div>
        </div>
    )
}
